import {
    USER_LOADED,
    USER_LOADING,
    AUTH_ERROR,
    LOGIN_SUCCESS,
    LOGIN_FAIL,
    LOGOUT_SUCCESS,
    CLEAR_ERROR,
    SET_LOGIN_VISIBILITY,
} from "../actions/types";

const initialState = {
    token: null,
    isAuthenticated: false,
    isLoading: false,
    user: null,
    error: false,
    showLogin: false,
};

export default (state = initialState, action) => {
    switch (action.type) {
        case CLEAR_ERROR:
            return {
                ...state,
                error: false,
            };
        case USER_LOADING:
            return {
                ...state,
                isLoading: true,
            };
        case USER_LOADED:
            return {
                ...state,
                isAuthenticated: true,
                isLoading: false,
                user: action.payload.data,
                token: action.payload.token,
                error: false,
            };
        case LOGIN_SUCCESS:
            return {
                ...state,
                ...action.payload,
                isAuthenticated: true,
                isLoading: false,
                error: false,
            };
        case LOGIN_FAIL:
            return {
                ...state,
                token: null,
                user: null,
                isAuthenticated: false,
                isLoading: false,
                error: true,
            };
        case AUTH_ERROR:
        case LOGOUT_SUCCESS:
            return {
                ...state,
                token: null,
                user: null,
                isAuthenticated: false,
                isLoading: false,
                error: false,
            };
        case SET_LOGIN_VISIBILITY:
            return {
                ...state,
                showLogin: action.payload,
            };
        default:
            return state;
    }
};
